'use strict';

var types = require('../../lib/types');
var types$1 = require('./types');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateWellKnownDid = /* @__PURE__ */ __name(({ wellKnown, newKeyPair }) => {
  if (!newKeyPair) {
    return;
  }
  if (wellKnown?.verificationMethod?.find((s) => {
    return newKeyPair.type === types.VerificationType.Bls12381G2Key2020 && s?.publicKeyBase58 && s?.publicKeyBase58 === newKeyPair?.publicKeyBase58 || newKeyPair.type === types.VerificationType.EcdsaSecp256k1RecoveryMethod2020 && s?.blockchainAccountId && s?.blockchainAccountId === newKeyPair?.blockchainAccountId;
  })) {
    throw new Error("KeyPair already exists");
  }
  if (!wellKnown) {
    wellKnown = {
      id: newKeyPair?.controller,
      [types$1.WellKnownEnum.VERIFICATION_METHOD]: [],
      "@context": [
        "https://www.w3.org/ns/did/v1"
      ]
    };
  }
  if (!wellKnown.id) {
    wellKnown.id = newKeyPair.controller;
  }
  const context = [
    "https://www.w3.org/ns/did/v1",
    types.VerificationContext[newKeyPair.type]
  ];
  if (!wellKnown["@context"]) {
    wellKnown["@context"] = context;
  } else {
    if (typeof wellKnown["@context"] === "string") {
      wellKnown["@context"] = [
        wellKnown["@context"]
      ];
    }
    for (const c of context) {
      if (!wellKnown["@context"].includes(c)) {
        wellKnown["@context"].push(c);
      }
    }
  }
  const newVerificationMethod = {
    type: newKeyPair.type,
    id: newKeyPair.id,
    controller: newKeyPair.controller
  };
  if (newKeyPair.type === types.VerificationType.Bls12381G2Key2020 && newKeyPair.publicKeyBase58) {
    newVerificationMethod.publicKeyBase58 = newKeyPair.publicKeyBase58;
  } else if (newKeyPair.type === types.VerificationType.EcdsaSecp256k1RecoveryMethod2020 && newKeyPair.blockchainAccountId) {
    newVerificationMethod.blockchainAccountId = newKeyPair.blockchainAccountId;
  }
  if (!wellKnown[types$1.WellKnownEnum.VERIFICATION_METHOD]) {
    wellKnown[types$1.WellKnownEnum.VERIFICATION_METHOD] = [
      newVerificationMethod
    ];
  } else if (!wellKnown[types$1.WellKnownEnum.VERIFICATION_METHOD]?.find((s) => s?.id === newVerificationMethod?.id)) {
    wellKnown[types$1.WellKnownEnum.VERIFICATION_METHOD].push(newVerificationMethod);
  } else {
    throw new Error("Key already exists");
  }
  for (const type of types$1.WellKnownAttribute) {
    if (!wellKnown[type]) {
      wellKnown[type] = [
        newVerificationMethod?.id
      ];
    } else {
      if (!wellKnown[type]?.includes(newVerificationMethod?.id)) wellKnown[type].push(newVerificationMethod?.id);
    }
  }
  return wellKnown;
}, "generateWellKnownDid");
const nextKeyId = /* @__PURE__ */ __name((wellKnown) => {
  const keyIds = wellKnown?.verificationMethod?.map((s) => s?.id) ?? [];
  const keyIdNumbers = keyIds.map((s) => {
    const parts = s?.split("#");
    if (!parts) return 0;
    return parts?.[parts.length - 1]?.split("keys-")?.[1];
  });
  const keyIdNumbersFiltered = keyIdNumbers.filter((s) => !Number.isInteger(s)).map((s) => Number(s));
  if (keyIdNumbersFiltered.length === 0) return 1;
  const maxKeyId = Math.max(...keyIdNumbersFiltered);
  return maxKeyId + 1;
}, "nextKeyId");

exports.generateWellKnownDid = generateWellKnownDid;
exports.nextKeyId = nextKeyId;
